module.exports = __webpack_public_path__ + "img/icon-template-light-blue.e27f8783.svg";